import { useEffect } from 'react'

export const APP_MARKETING_EXCEL_UPLOAD_LEAVE_MESSAGE = '엑셀 업로드는 완료 전에 이동하면 취소될 수 있습니다. 이동하시겠습니까?'

// 엑셀 업로드 요청이 진행 중일 때만 화면 이탈 경고를 띄운다.
export const usePendingAppMarketingExcelUploadUnloadGuard = (enabled) => {
    useEffect(() => {
        if (typeof window === 'undefined' || !enabled) {
            return undefined
        }

        const handleBeforeUnload = (event) => {
            event.preventDefault()
            event.returnValue = ''
            return ''
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [enabled])
}
